import React, { createContext, useContext, useState, useCallback } from 'react';
import NotificacionModal from './notificacion-modal';

const NotificationModalContext = createContext();

export const NotificationModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState({
    isOpen: false,
    setIsOpen: () => {},
    message: '',
    type: '',
  });

  const openNotificationModal = useCallback((props) => {
    setModalProps({
      ...props,
      isOpen: true,
      setIsOpen: () => setModalProps((prev) => ({ ...prev, isOpen: false })),
    });
  }, []);

  return (
    <NotificationModalContext.Provider value={{ openNotificationModal }}>
      {children}
      <NotificacionModal {...modalProps} />
    </NotificationModalContext.Provider>
  );
};

export const useNotificationModal = () => {
  const context = useContext(NotificationModalContext);
  if (!context) {
    throw new Error('useNotificationModal must be used within a NotificationModalProvider');
  }
  return context;
};
